export default __webpack_public_path__ + "static/case-6-hero-c1c507a3a948df2bfd44f01f7bd75d2e.png";